import React from 'react';
import './Spinner.css'; // Import the CSS for styling

const Spinner = ({style}) => {
    return (
        <div className="spinner" style={style}>
            {/* You can add an optional text or leave it empty */}
        </div>
    );
};

export default Spinner; 